import { Authenticator, Image, Text, View, useTheme } from "@aws-amplify/ui-react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { siteName } from "@/constants/config";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useNavigateLogin from "@/hooks/useNavigateLogin";
import usePlatform from "@/hooks/usePlatform";

function Auth() {
  const { isPc } = usePlatform();
  const components = {
    Header() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" style={{ width: "100%", marginTop:"-100px" }} padding={tokens.space.small}>
          <Image
            style={{ width: "100%", maxHeight: "0px" }}
            alt={siteName}
          // src="https://img.awardtool.com/awardtool_logo_email.jpg"
          />
          <Image
            style={{
              maxHeight: "100px",
              marginTop: isPc ? "150px" : "0px",
              marginBottom: isPc ? "5px" : "-10px",
              marginRight: isPc ? "80px" : "30px",
            }}
            alt={siteName}
            src="https://img.awardtool.com/awardtool_logo_email.jpg"
          />
        </View>
      );
    },

    Footer() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Text
            style={{ width: "100%", maxHeight: "100px", marginTop: isPc ? "0px" : "" }}
            color={tokens.colors.neutral[40]}
          >
            &copy; {"2023 " + siteName + " LLC"}
          </Text>
        </View>
      );
    },
  };

  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  const navigate = useNavigate();

  const { getRedirectUrl } = useNavigateLogin();

  useEffect(() => {
    if (authStatus === "authenticated") {
      location.href = getRedirectUrl() || "/";
    }
  }, [authStatus, getRedirectUrl, navigate]);

  return <Authenticator components={components} />;
}

const AuthRoot = () => {
  return (
    <Authenticator.Provider>
      <Auth />
    </Authenticator.Provider>
  );
};

export default AuthRoot;
